import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import { useTranslation } from "react-i18next";
import { Stack } from "@mui/system";
import { TextField, Typography } from "@mui/material";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import AlertDialogComponent from "./AlertDialogComponent";
import { purchasePrize } from "../redux/slices/giftsProductsSlice";
import { getMe } from "../redux/slices/userSlice";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const OrderPrizeDialog = ({
  open,
  onClose,
  selectedGift,
  totalPoints,
  onSuccessOrderGift,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const notEnoughPoints = selectedGift?.points > totalPoints;
  const [showOrderForm, setShowOrderForm] = useState(false);
  const userMe = useSelector((state) => state.user.userMe);
  const currentUserId = useSelector((state) => state.user.currentUserId);

  const [name, setName] = useState();
  const [surname, setSurname] = useState();
  const onChangeName = (event) => {
    setName(event.target.value);
  };
  const [idNum, setIdNum] = useState();
  const onChangeIdNum = (event) => {
    setIdNum(event.target.value);
  };
  const onChangeSurname = (event) => {
    setSurname(event.target.value);
  };
  const [email, setEmail] = useState();
  const onChangeEmailInput = (event) => {
    setEmail(event.target.value);
  };
  const [address, setAddress] = useState();
  const onChangeAddressInput = (event) => {
    setAddress(event.target.value);
  };
  const [city, setCity] = useState();
  const onChangeCityInput = (event) => {
    setCity(event.target.value);
  };
  const [phoneNumber, setPhoneNumber] = useState();
  const onChangePhoneNumberInput = (event) => {
    setPhoneNumber(event.target.value);
  };
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);

  useEffect(() => {
    if (showOrderForm && userMe) {
      setEmail(userMe.email);
      setPhoneNumber(userMe.phone);
    }
  }, [showOrderForm, userMe]);

  const isFormValid = () => {
    return (
      name &&
      surname &&
      email &&
      isEmailValid() &&
      address &&
      city &&
      idNum &&
      phoneNumber &&
      isPhoneNumberValid()
    );
  };
  const onNext = () => {
    setShowOrderForm(true);
  };
  const isEmailValid = () => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const isPhoneNumberValid = () => {
    return /^[0-9]{10}$/.test(phoneNumber);
  };

  const onConfirmOrderGift = () => {
    setShowConfirmDialog(true);
  };
  const handleOnConfirmOrderingGift = () => {
    setShowConfirmDialog(false);
    // const user = { objectId: currentUserId, email: userMe.email };
    const user = { objectId: currentUserId, email: email };
    const prize = selectedGift;
    const shippingInfo = {
      username: userMe.username,
      name,
      surname,
      email,
      phoneNumber,
      address,
      city,
      idNum,
    };
    dispatch(getMe()).then(() =>
      dispatch(purchasePrize({ user, prize, shippingInfo })).then(() =>
        onSuccessOrderGift()
      )
    );
  };

  function textInfoContent() {
    return (
      <Stack marginTop="12px" marginBottom="12px" padding="0 24px">
        <Typography id="alert-dialog-slide-description">
          {t(
            showOrderForm
              ? "orderGiftDialog.orderInfoText"
              : notEnoughPoints
              ? "orderGiftDialog.notEnoughPointsInfo"
              : selectedGift.stock === 0
              ? "orderGiftDialog.notInStock"
              : "orderGiftDialog.generalInfo"
          )}
        </Typography>
      </Stack>
    );
  }
  function orderForm() {
    return (
      <Stack
        direction="column"
        display="flex"
        justifyContent="center"
        padding="0 24px"
      >
        <TextField
          autoFocus
          margin="dense"
          id="name"
          label={t("orderGiftDialog.name")}
          type="text"
          fullWidth
          variant="standard"
          value={name}
          onChange={onChangeName}
          required
          error={name === ""}
          helperText={name === "" ? t("errors.requiredField") : ""}
          InputLabelProps={{
            shrink: true,
          }}
        />
        <TextField
          margin="dense"
          id="surname"
          label={t("orderGiftDialog.surname")}
          type="text"
          fullWidth
          variant="standard"
          value={surname}
          onChange={onChangeSurname}
          required
          error={surname === ""}
          helperText={surname === "" ? t("errors.requiredField") : ""}
          InputLabelProps={{
            shrink: true,
          }}
        />
        <TextField
          margin="dense"
          id="idNum"
          label={t("orderGiftDialog.idNum")}
          type="number"
          fullWidth
          variant="standard"
          value={idNum}
          onChange={onChangeIdNum}
          required
          error={idNum === ""}
          helperText={idNum === "" ? t("errors.requiredField") : ""}
          InputLabelProps={{
            shrink: true,
          }}
        />
        <TextField
          disabled={true}
          margin="dense"
          id="email"
          label={t("orderGiftDialog.email")}
          type="email"
          fullWidth
          variant="standard"
          value={email || ""}
          onChange={onChangeEmailInput}
          required
          error={(!isEmailValid() && email !== "") || email === ""}
          helperText={
            !isEmailValid() && email !== "" ? t("errors.emailInvalid") : ""
          }
          InputLabelProps={{
            shrink: true,
          }}
        />
        <TextField
          margin="dense"
          id="phone"
          label={t("orderGiftDialog.phone")}
          type="tel"
          fullWidth
          variant="standard"
          value={phoneNumber || ""}
          onChange={onChangePhoneNumberInput}
          required
          error={
            (!isPhoneNumberValid() && phoneNumber !== "") || phoneNumber === ""
          }
          helperText={
            !isPhoneNumberValid() && phoneNumber !== ""
              ? t("errors.phoneNumberInvalid")
              : ""
          }
          InputLabelProps={{
            shrink: true,
          }}
        />
        <TextField
          margin="dense"
          id="address"
          label={t("orderGiftDialog.address")}
          type="text"
          fullWidth
          variant="standard"
          value={address}
          onChange={onChangeAddressInput}
          required
          error={address === ""}
          helperText={address === "" ? t("errors.requiredField") : ""}
          InputLabelProps={{
            shrink: true,
          }}
        />
        <TextField
          margin="dense"
          id="city"
          label={t("orderGiftDialog.city")}
          type="text"
          fullWidth
          variant="standard"
          value={city}
          onChange={onChangeCityInput}
          required
          error={city === ""}
          helperText={city === "" ? t("errors.requiredField") : ""}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Stack>
    );
  }

  return (
    <div>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={onClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{t("orderGiftDialog.title")}</DialogTitle>
        <Stack maxHeight="70vh" overflow="auto">
          <Stack display="flex" direction="column" alignItems="center">
            <img src={selectedGift?.photo?.url} width="200px" alt="prize" />
            <Typography variant="body">{selectedGift?.name}</Typography>
          </Stack>
          {textInfoContent()}
          {showOrderForm && orderForm()}
        </Stack>
        {showOrderForm ? (
          <DialogActions>
            <Button onClick={onClose}>{t("orderGiftDialog.cancel")}</Button>
            {!notEnoughPoints && (
              <Button disabled={!isFormValid()} onClick={onConfirmOrderGift}>
                {t("orderGiftDialog.confirm")}
              </Button>
            )}
          </DialogActions>
        ) : (
          <DialogActions>
            <Button onClick={onClose}>{t("orderGiftDialog.cancel")}</Button>
            {!notEnoughPoints && selectedGift.stock > 0 && (
              <Button onClick={onNext}>{t("orderGiftDialog.next")}</Button>
            )}
          </DialogActions>
        )}
      </Dialog>
      {showConfirmDialog && (
        <AlertDialogComponent
          open={showConfirmDialog}
          onClose={() => setShowConfirmDialog(false)}
          title={t("orderGiftDialog.confirmOrderingGiftTitle")}
          text={t("orderGiftDialog.confirmOrderingGiftExplanation")}
          onConfirm={handleOnConfirmOrderingGift}
        />
      )}
    </div>
  );
};
export default OrderPrizeDialog;
